const ContinueReturnIconSubcategory = () => {
  return (
    <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="70" height="70" rx="14.5455" fill="url(#paint0_linear_2217_10937)" />
      <path
        d="M44.18 52.5757C53.1242 49.6071 58.1296 40.4349 55.7631 31.5823C53.4901 23.0724 45.5656 18.2617 38.0537 18.5357C38.0537 19.3426 38.0537 20.1494 38.0537 21.04C35.1345 19.609 32.3088 18.2312 29.3975 16.8078C32.301 15.3844 35.1345 13.9991 38.0459 12.5757C38.0459 13.4663 38.0459 14.2655 38.0459 15.0952C44.6938 15.1713 50.1195 17.6604 54.1518 22.8136C57.032 26.5053 58.3086 30.745 58.0362 35.3806C57.4913 44.7508 50.4464 50.9468 44.18 52.5757Z"
        fill="white"
      />
      <g opacity="0.6">
        <path
          d="M26.2897 18C17.3455 20.9686 12.3401 30.1408 14.7066 38.9933C16.9796 47.5033 24.9041 52.314 32.416 52.04C32.416 51.2331 32.416 50.4263 32.416 49.5357C35.3352 50.9667 38.1609 52.3444 41.0723 53.7678C38.1687 55.1912 35.3352 56.5766 32.4238 58C32.4238 57.1094 32.4238 56.3102 32.4238 55.4805C25.776 55.4044 20.3503 52.9153 16.318 47.7621C13.4377 44.0704 12.1611 39.8306 12.4336 35.1951C12.9785 25.8249 20.0233 19.6289 26.2897 18Z"
          fill="white"
        />
      </g>
      <path
        d="M43.3745 27H37.7473V34.7178L35.4964 33.0055L33.2455 34.7178V27H27.6254C27.009 27 26.5 27.5817 26.5 28.2863V43.7137C26.5 44.4183 27.009 45 27.6254 45H43.3745C43.991 45 44.5 44.4183 44.5 43.7137V28.2781C44.5 27.5735 43.991 27 43.3745 27Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2217_10937"
          x1="35"
          y1="0"
          x2="35"
          y2="70"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FFB300" />
          <stop offset="1" stop-color="#EA8D03" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default ContinueReturnIconSubcategory
